import { createSlice } from '@reduxjs/toolkit';

const initialState = {

    personalEmail: "",
    isBasicDetailsFilled: false,
    image: {
        base64: null,
        type: '',
    },
    firstName: "",
    lastName: "",
    gender: "",
    mailingAddress: "",
    zipCode: '',
    subDivisionName : '',
    subDivisionCategory : '',
    state: "",
    city: "",
    subDivisionCode : '',
    emergencyNumber: null,
    countryCode: "44",
    country: "UK",
    isEmailVerified: false,
    personalPhoneNumber: null,
    verifyOtp: false,

    uploadedDocuments: [
        {
            base64: null,
            documentName: '',
            type: '',
            documentType: '',
        },
        {
            base64: null,
            documentName: '',
            type: '',
            documentType: '',
        },
        // {
        //     base64: null,
        //     documentName: '',
        //     type: '',
        //     documentType: '',
        // },
        {
            base64: null,
            documentName: '',
            type: '',
            documentType: '',
        },
        {
            base64: null,
            documentName: '',
            type: '',
            documentType: '',
        },
    ],
    isUsaHiringDocsCollected: false,
    declaration: false,
    grantPermission : false,
};

export const sliceName = 'recruitment'

export const recruitmentSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {

        setBasicDetailsFilled: (state, action) => {
            state.isBasicDetailsFilled = action.payload
        },

        setBasicDetails: (state, action) => {
            const { personalEmail, isEmailVerified, image, firstName, lastName, gender, mailingAddress, zipCode: zipCode, state: stateName, city, emergencyNumber, countryCode, personalPhoneNumber, verifyOtp , subDivisionName , subDivisionCategory , subDivisionCode } = action.payload
            state.personalEmail = personalEmail
            state.isEmailVerified = isEmailVerified
            state.image = image
            state.firstName = firstName
            state.lastName = lastName
            state.gender = gender
            state.mailingAddress = mailingAddress
            state.zipCode = zipCode
            state.state = stateName
            state.subDivisionCode = subDivisionCode
            state.subDivisionName = subDivisionName
            state.subDivisionCategory = subDivisionCategory
            state.city = city
            state.emergencyNumber = emergencyNumber
            state.countryCode = countryCode
            state.personalPhoneNumber = personalPhoneNumber
            state.countryCode = countryCode
            state.verifyOtp = verifyOtp
        },
        setUsaHiringDocuments: (state, action) => {
            const { index, data } = action.payload
            state.uploadedDocuments[index] = data



            if (state.uploadedDocuments[0].base64 && state.uploadedDocuments[1].base64 && ((state.state == "Texas") || state.uploadedDocuments[2].base64) && state.uploadedDocuments[3].base64) {
                state.isUsaHiringDocsCollected = true

            }
            else if (state.uploadedDocuments[0].base64 || state.uploadedDocuments[1].base64 || state.uploadedDocuments[2].base64 || state.uploadedDocuments[3].base64) {
                state.isUsaHiringDocsCollected = false
            }
        },
        setDeclaration: (state, action) => {
            state.declaration = action.payload.declaration
        },
        setGrantPermission : (state , action) => {
         state.grantPermission = action.payload.grantPermission
        },
        resetAllRecruitmentData: (state, action) => {
            return state = initialState;
        },
    }
});

export const {
    setBasicDetailsFilled,
    setEmailID,
    updateHiringType,
    setBasicDetails,
    resetAllRecruitmentData,
    setExperiencesData,
    setWorkExperienceDocs,
    setUsaHiringDocuments,
    setUsaHiringEducationDetails,
    // setReferenceChecks,
    setDeclaration,
    setGrantPermission
} = recruitmentSlice.actions;


export const selectIsBasicDetailsFilled = state => state[sliceName].isBasicDetailsFilled;

export const selectAllData = state => state[sliceName];

export const basicDetailsDataRedux = state => state[sliceName]

export const selectUsaHiringDocumentDetails = state => state[sliceName].usaHiringDocuments


export default recruitmentSlice.reducer